import { Table } from "@findemdev/maui";
import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  width: 100%;
`;

export const StyledTable = styled(Table)`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  padding: 0px ${({ theme }) => theme.dimensions.spacing[4]};

  .ant-spin-nested-loading,
  .ant-spin-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }

  .ant-table {
    flex: 1 1 auto;
    min-height: 0;
  }

  .ant-table-header {
    height: 46px;

    * {
      color: ${({ theme }) => theme.colors['grey-600']};
      font-weight: 400;
    }
  }

  .cred-list-rows {
    cursor: pointer;
  }

  .ant-pagination {
    flex-shrink: 0;
    margin: ${({ theme }) => `${theme.dimensions.spacing[3]} ${theme.dimensions.spacing[4]} ${theme.dimensions.spacing[5]} 0`};
  }
` as typeof Table;

export const CheckboxWrapper = styled.span`
  // margin-left: 12px;
  margin-right: 8px;
`;

export const CredentialName = styled.span`
  color: ${({ theme }) => theme.colors['grey-700']};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`;

export const ItemContainer = styled.div`
  display: flex;
  vertical-align: -2px;
  color: ${({ theme }) => theme.colors['grey-500']};
  gap: 4px;
`;
